module.exports = __webpack_public_path__ + "img/18.ff5891d0.jpg";